export const base_config = {
    MONITORING_TRACING: {
        SENTRY: {
            ACTIVO: false,
        },
        HANDLE_ERROR: {
            CONSOLE_LOG: true,
        },
    },
    IDLE: {
        ACTIVO: true,
        TIEMPO_SESION: 900,
        TIEMPO_AVISO: 180,
    },
    LOADING: {
        bdColor: 'rgba(255,255,255,0.5)',
        color: '#106eea',
    },
    REPORT: {
        TYPE: {
            pdf: 'application/pdf',
            xls: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            doc: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        },
    },
    SISTEMA: {
        NOMBRE: 'Universidad de Valparaíso', // Nombre por defecto. Es reemplazado por el registrado en PanelControl
        LOGIN: false, // El sistema operara o no en base a token
        GET_DATA: false, // Si el sistema no opera con token, se da la posibilidad de obtener datos (menus,modulos,aplicaciones)
        BREADCRUMB: false, // Migas de pan
        HOME: false, // Incluir menu "Inicio" al conjunto de menus,
        LANDING: '',
        URL: {
            PORTAL: 'https://portal.uv.cl',
            CAMBIA_CLAVE: 'https://cambiaclave.uv.cl',
            REPOSITORIO: 'https://repositorio.uv.cl/',
            PATHAPPSIMG: 'imagenes/iconos_sistemas/aplicaciones/',
            PATHMODULOSIMG: 'imagenes/iconos_sistemas/modulos/',
            PATHMENUSIMG: 'imagenes/iconos_sistemas/menus/base/',
            PATHITEMSIMG: 'imagenes/iconos_sistemas/menus/items/base/',
            PATHSTATIC: '/static/sistemas/base/',
            PATH404IMG:
                'https://repositorio.uv.cl/imagenes/iconos_sistemas/menus/base/noicon.png',
        },
        LOADS: {
            APPS: { BUTTON: false, DATA: false },
            MODULOS: { BUTTON: false, DATA: false },
            MENUS: { BUTTON: false, DATA: false },
            NOTICIAS: { BUTTON: false, DATA: false },
            AVISOS: { BUTTON: false, DATA: false },
            USUARIO: { DATA: false },
            VOLVER_PORTAL: { BUTTON: false },
            FECHA: { DATA: false },
        },
        LINKS: {
            AYUDA: {
                ACTIVO: false,
                BUTTONS: {
                    CONTACTO: false,
                    SIMBOLOGIA: false,
                },
            },
            USUARIO: {
                ACTIVO: false,
                BUTTONS: {
                    PROFILE: false,
                    CORREO: false,
                    CAMBIA_CLAVE: false,
                    LOG_OUT: false,
                },
            },
        },
        MENUS: {
            ITEMS_ICON: false,
            FLAT_ICONS: false,
            METODO_ACTIVO: '',
        },
        TRANSLATE: {
            ACTIVO: false,
            IDIOMAS: [
                { label: 'Español', value: 'es' },
                { label: 'English', value: 'en' },
            ],
            DEFAULT: 'es',
        },
        CORREO_UV: {
            PREGRADO: 'http://correo.alumnos.uv.cl/',
            POSTGRADO: 'http://correo.postgrado.uv.cl/',
            FUNCIONARIO: 'http://correo.uv.cl/',
            EN_USO: 'FUNCIONARIO',
        },
    },
    DTIC: {
        NOMBRE: 'Dirección de Tecnologías de Información y Comunicación',
        URL: 'https://dtic.uv.cl',
        SIGLA: 'DTIC',
    },
    UV: {
        NOMBRE: 'Universidad de Valparaíso',
        URL: 'https://uv.cl',
        SIGLA: 'UV',
    },
    TUI: {
        URL_FOTO: 'https://admintui.uv.cl/data/fotos2/',
        FORMATO_FOTO: '.jpg',
        URL_TUI: 'https://tui.uv.cl/',
    },
};
